import './styles.scss';
import React, {Dispatch, useEffect} from "react";

/* Types, Constants, Utils */
import * as Constants from "../../constants";
import {PageContext} from "../../types/app";

/* Bootstrap */
import {Container} from "react-bootstrap";

/* Components */
import IndustryMenu from "../../components/industry-menu";
import ViewScrollContainer from "../../components/view/view-scroll-container";

/* hooks */
import SearchInput from "../../components/search/search-input";
import {setIndustry} from "../../redux/slices/search-slice";
import {clearPrevBibliographySearchState, clearPrevDocumentSearchState} from "../../redux/slices/prev-search-slice";
import {AnyAction} from "@reduxjs/toolkit";
import {useDispatch} from "react-redux";
import useSearchReset from "../../hooks/useSearchReset";

const Home = ():JSX.Element => {
  const dispatch:Dispatch<AnyAction> = useDispatch();
  const searchResetHook: Function = useSearchReset();

  useEffect(()=>{
    window.history.replaceState(null, '', '/' + Constants.HOME + '/');

    /* reset search and industry on arrival of home view */
    searchResetHook(Constants.DOCUMENTS);
    dispatch(setIndustry(Constants.ALL_INDUSTRIES))
    dispatch(clearPrevDocumentSearchState());
    dispatch(clearPrevBibliographySearchState());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={'home'}>
      <PageContext.Provider value={{context: Constants.HOME}}>
        <ViewScrollContainer className={'view-no-breadcrumb'}>

          <Container className={'input-component'}>
            <div className={'input-container m-auto mb-3 mt-2'}>
              <h2 className={'text-center pt-3 mt-4 mb-4'}>What are you looking for?</h2>
              <div className={'search-input-container shadow rounded border border-secondary'}>
                <SearchInput
                  minimal={true}
                />
              </div>
            </div>

            {/* industry cards */}
            <IndustryMenu/>
          </Container>

        </ViewScrollContainer>
      </PageContext.Provider>
    </div>
  )
}

export default Home;
